import moment from 'moment';
import dataCacheService from './DataCacheService';

class DateFormatService {
  tenantConfiguration;

  constructor() {
    this.tenantConfiguration = dataCacheService.getTenantConfiguration();
  }

  dateFormat = () => this.correctFormatForConfiguration('DD/MM/yyyy');
  dateWithTimeFormat = () => this.correctFormatForConfiguration('DD/MM/yyyy HH:mm');
  dateDayMonthFormat = () => this.correctFormatForConfiguration('DD/MM');
  dateLongFormat = () => this.correctFormatForConfiguration('DD/MM/yyyy');
  dateInFullFormat = () => this.correctFormatForConfiguration('dddd D MMMM YYYY');

  formatDate = (input, isUtc) => this.format(input, this.dateFormat(), isUtc);
  formatDateWithTime = (input, isUtc) => this.format(input, this.dateWithTimeFormat(), isUtc);
  formatDayMonth = input => this.format(input, this.dateDayMonthFormat());
  formatDateLong = input => this.format(input, this.dateLongFormat());
  formatDateInFull = input => this.format(input, this.dateInFullFormat());

  format = (input, format, isUtc) => {
    if (!input) return input;

    if (input instanceof moment) return input.format(format);

    return isUtc ? moment.utc(input).format(format) : moment(input).format(format);
  };

  correctFormatForConfiguration(format) {
    const delimiter = this.delimiter();
    return format.toString().replaceAll('/', delimiter);
  }

  delimiter() {
    if (this.tenantConfiguration === false)
      this.tenantConfiguration = dataCacheService.getTenantConfiguration();
    return this.tenantConfiguration === 5 ? '-' : '/';
  }
}

const dateFormatService = new DateFormatService();
export default dateFormatService;
